<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Group</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :descWidth="100" :codes="classGroups" v-model="classGroup" />
				</span>

				<em class="lt_text">Dept A</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :width="50" :descWidth="70" :codes="deptAs" v-model="deptA" />
				</span>

				<em class="lt_text">Dept B</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :width="50" :descWidth="70" :codes="deptBs" v-model="deptB" />
				</span>

				<em class="lt_text">Category</em>
				<span class="int_type_no_border mgr_5">
					<CodeSelect :width="100" :codeWidth="110" :nameWidth="500" :codes="categories" :showDesc="false" v-model="category" />
				</span>

				<span class="int_type mgr_5">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }} </option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }} </option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="hot_yn" class="tbl_select sm_int">
						<option value="">All</option>
						<option value="Y">Hot</option>
						<option value="N">Not Hot</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="new_yn" class="tbl_select sm_int">
						<option value="">All</option>
						<option value="Y">New</option>
						<option value="N">Not New</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<select v-model="discount_yn" class="tbl_select sm_int">
						<option value="">All</option>
						<option value="Y">Discount</option>
						<option value="N">Not Discount</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<input type="text" v-model="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_small2_tbl" style="height: 795px; overflow-y: auto;">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
					<thead>
						<tr>
							<th style="text-align:center;width:1%;"></th>
							<!-- <th style="text-align:center;width:10%;">Class Code</th> -->
							<th style="text-align:center;width:10%;">{{ headers.class }} Code</th>
							<th style="text-align:center;width:10%;">WH Code</th>
							<th style="text-align:center;">{{ headers.class }} Name</th>
							<!-- <th style="text-align:center">Description</th> -->
							<th style="text-align:center;width:20%;">Group</th>
							<!-- <th style="text-align:center;width:3%;">A</th>
							<th style="text-align:center;width:3%;">B</th>
							<th style="text-align:center;width:3%;">Cat.</th> -->
							<th style="text-align:center;width:3%;">Closed</th>
							<th style="text-align:center;width:3%;">Active</th>
							<th style="text-align:center;width:3%;">Items</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="item in itemClasses" v-bind:key="item.code" v-bind:class="{ on: item.code == selectedItemClass.code }" @click="selectRow(item)">
							<td class="al_center"><img v-img v-if="item.image_file_name" :src="getImageUrl(item.image_file_name)" alt="File Not Found" style="cursor: zoom-in;max-height:20px;max-width:15px;height:auto;width:auto;" /></td>
							<td>
								<font :color="item.so_blocked ? 'red' : 'black'">{{ item.code }}</font>
							</td>
							<td>
								<font :color="item.so_blocked ? 'red' : 'black'">{{ item.wh_code }}</font>
							</td>
							<td class="truncate">
								<font :color="item.so_blocked ? 'red' : 'black'"
									><span :title="item.name">{{ item.name }}</span></font
								>
							</td>
							<!-- <td class="truncate">
								<span :title="item.description">{{ item.description }}</span>
							</td> -->
							<td class="truncate">
								<span :title="item.class_group_name">{{ item.class_group_name }}</span>
							</td>
							<!-- <td>{{ item.dept_a_code }}</td>
							<td>{{ item.dept_b_code }}</td>
							<td>{{ item.category_code }}</td> -->
							<td style="text-align:center;">{{ item.closed_yn }}</td>
							<td style="text-align:center;">{{ item.active_yn }}</td>
							<td style="text-align:right;">{{ item.item_count }}</td>
						</tr>
					</tbody>
				</table>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a v-if="modifiable" href="javascript:;" class="gray_bt" style="float:left;" @click="bulkPictureFolderPick()">Bulk Upload Pictures</a>
					<input type="file" v-show="false" ref="bulkPictureInput" class="file_input_hidden" accept="image/*" multiple webkitdirectory directory @change="bulkPictureFolderSelected()" />
					<span class="int_type_no_border mgr_15">
						<PageSizeSelect v-model="page_size" @input="search()" />
					</span>
					<a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
					<a v-if="modifiable" href="javascript:;" :class="selectedItemClass.code && mode == 'detail' ? 'gray_bt' : 'disable_bt'" @click="clone()">Clone</a>
				</div>
			</div>

			<div class="right_big2_tbl" style="height:765px;">
				<div>
					<h4 class="inner_h5">{{ detailTitle }}</h4>
					<table class="view_tbl2" border="0">
						<colgroup>
							<col style="width:110px;" />
							<col style="" />
							<col style="width:90px;" />
							<col style="" />
							<col style="width:250px;" />
						</colgroup>
						<tbody>
							<tr v-if="modifiable">
								<td colspan="2">Created : {{ itemClass.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ itemClass.crt_user }}</td>
								<td colspan="2">Last updated : {{ itemClass.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ itemClass.upd_user }}</td>
								<td rowspan="8" valign="top" style="padding-left:10px">
									<template v-if="user.fob_price_view">
										<h4 class="inner_h5">FOB Price <input type="button" value="Add Row" class="btn" @click="addFobRow()" style="margin-top:-3px;" /></h4>
										<div class="fixed-table-container" style="height:190px;" v-show="true">
											<!-- <div class="table-wrapper" style="height:410px;"> -->
											<div class="table-wrapper">
												<table id="fob_list" class="list_tbl" border="0">
													<thead>
														<tr>
															<th style="text-align:center;width:20px;">
																<div class="th-text">M</div>
															</th>
															<th style="text-align:center;">
																<div class="th-text">Vendor Code</div>
															</th>
															<th style="text-align:center;width:70px;">
																<div class="th-text">Price</div>
															</th>
															<th style="text-align:center;width:45px;">
																<div class="th-text">Del</div>
															</th>
														</tr>
													</thead>

													<tbody>
														<!-- <tr v-for="item in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id == selectedItem.item_id }" @click="openModal('ItemDetail', item)"> -->
														<tr v-for="(fob, index) in fobs" v-bind:key="index">
															<td><input type="checkbox" ref="fobCheck" v-model="fob.main" @change="mainChanged(fob, index)" /></td>
															<td>
																<input type="text" v-model.trim="fob.vendor_code" class="l_int long_type" @focus="$event.target.select()" @blur="checkVendor(fob)" />
															</td>

															<td class="al_right">
																<currency-input type="text" class="r_int long_type al_right" v-model="fob.price" @focus="$event.target.select()" />
															</td>
															<td class="al_center">
																<input type="button" value="Del" class="btn" @click="delRow(index)" style="margin-top:-3px;" />
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</template>
								</td>
							</tr>
							<tr>
								<th>{{ headers.class }} Code</th>
								<td>
									<input type="text" v-model.trim="itemClass.code" ref="code" class="tbl_int sm_int" v-bind:disabled="mode != 'add'" />
									<button v-if="mode == 'add' && user.company_id == 'he'" v-bind:disabled="!itemClass.code" class="gray_bt2" @click="generateCode()">Generate</button>
									<button v-if="mode == 'add'" v-bind:disabled="!itemClass.code" class="gray_bt2" @click="checkDup()">Check Dup.</button>
									<template v-if="itemClass.so_blocked">
										<font color="red">Blocked in SO</font>
									</template>
								</td>
								<th>Packing</th>
								<td>
									<currency-input type="text" ref="classPacking" v-model.trim="itemClass.packing" :precision="0" :allow-negative="false" @keydown.down.prevent="$refs.classWeight.$el.select()" class="tbl_int ssm_int al_right" />
									per 1 box
									<a v-if="modifiable" href="javascript:;" class="gray_bt2" style="margin-left:15px;" @click="applyPackingToItems()">Apply to Item(s)</a>
								</td>
							</tr>
							<tr>
								<th>Warehouse Code</th>
								<td>
									<input type="text" v-model.trim="itemClass.wh_code" class="tbl_int sm_int" disabled />
									<a v-if="(user.company_id == 'beautyplus' || user.company_id == 'hairplus') && modifiable && mode == 'detail' && itemClass.wh_code" href="javascript:;" class="gray_bt2" style="margin-left:0px;" @click="clearWhCode()">Clear</a>
									<a
										v-if="(user.company_id == 'beautyplus' || user.company_id == 'hairplus') && modifiable && mode == 'detail' && itemClass.class_group_code && !itemClass.wh_code"
										href="javascript:;"
										class="gray_bt2"
										style="margin-left:0px;"
										@click="setNewWhCode()"
										>Set Code</a
									>
								</td>
								<th>Weight(LBS)</th>
								<td>
									<currency-input
										type="text"
										ref="classWeight"
										v-model.trim="itemClass.weight_per_box"
										:precision="2"
										:allow-negative="false"
										class="tbl_int ssm_int al_right"
										@keydown.down.prevent="$refs.classRack.select()"
										@keydown.up.prevent="$refs.classPacking.$el.select()"
									/>
									per 1 box
									<a v-if="modifiable" href="javascript:;" class="gray_bt2" style="margin-left:15px;" @click="applyWeightPerBoxToItems()">Apply to Item(s)</a>
								</td>
							</tr>
							<tr>
								<th>Factory Code / Item Number</th>
								<td>
									<input type="text" v-model.trim="itemClass.factory_code" class="tbl_int ssm2_int" />
									/ <input type="text" v-model.trim="itemClass.factory_item_no" class="tbl_int ssm2_int" />
								</td>
								<th>Rack / Section</th>
								<td>
									<input
										type="text"
										ref="classRack"
										v-model.trim="itemClass.rack"
										style="margin-right:4px;"
										class="tbl_int sssm_int"
										@keydown.up.prevent="$refs.classWeight.$el.select()"
										@keydown.down.prevent="$refs.classSection.select()"
										@keydown.right.prevent="$refs.classSection.select()"
									/>
									/ <input type="text" ref="classSection" v-model.trim="itemClass.section" style="margin-left:4px;" class="tbl_int sssm_int" @keydown.up.prevent="$refs.classRack.select()" @keydown.left.prevent="$refs.classRack.select()" />
									<a v-if="modifiable" href="javascript:;" class="gray_bt2" style="margin-left:15px;" @click="applyRackSectionToItems()">Apply to Item(s)</a>
								</td>
							</tr>
							<tr>
								<th>{{ headers.class }} Name</th>
								<td><input type="text" v-model.trim="itemClass.name" class="tbl_int full_int" /></td>
								<th>Location</th>
								<td>
									<select v-model="itemClass.location_code" class="tbl_select ssm_int">
										<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
									</select>
									<a v-if="modifiable" href="javascript:;" class="gray_bt2" style="margin-left:15px;" @click="applyLocationToItems()">Apply to Item(s)</a>
								</td>
							</tr>

							<tr>
								<th>Description</th>
								<td><input type="text" v-model.trim="itemClass.description" class="tbl_int full_int" /></td>
								<th>Tariff Rate(%)</th>
								<td>
									<currency-input type="text" v-model.trim="itemClass.tariff_rate" :precision="1" :valueRange="{ min: 0, max: 99.9 }" :allow-negative="false" class="tbl_int ssm_int al_right" />
									<a v-if="modifiable" href="javascript:;" class="gray_bt2" style="margin-left:15px;" @click="applyTariffRateToItems()">Apply to Item(s)</a>
								</td>
							</tr>

							<tr>
								<th>Box Dimension</th>
								<td colspan="3">
									( L:<currency-input type="text" ref="classBoxLength" v-model.trim="itemClass.box_length" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @keydown.right.prevent="$refs.classBoxWidth.$el.select()" />
									W:
									<currency-input
										type="text"
										ref="classBoxWidth"
										v-model.trim="itemClass.box_width"
										:precision="1"
										:valueRange="{ min: 0 }"
										class="tbl_int sss2m_int al_right"
										@keydown.left.prevent="$refs.classBoxLength.$el.select()"
										@keydown.right.prevent="$refs.classBoxHeight.$el.select()"
									/>
									H:
									<currency-input type="text" ref="classBoxHeight" v-model.trim="itemClass.box_height" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @keydown.left.prevent="$refs.classBoxWidth.$el.select()" /> ) , UPS DIM
									Weight :
									<currency-input type="text" :value="getUpsDimWeight()" :precision="1" readonly class="tbl_int sssm_int al_right" />
									<a v-if="modifiable" href="javascript:;" class="gray_bt2" style="margin-left:15px;" @click="applyDimensionToItems()">Apply to Item(s)</a>
									<span v-if="getUpsDimWeight() > 49" class="mgl_15" style="color:red;">Weight exceeded</span>
								</td>
							</tr>
							<template v-if="user.company_id == 'hairplus'">
								<tr>
									<th>Pkg. Dimension</th>
									<td>
										( L:<currency-input type="text" ref="classBoxLength" v-model.trim="itemClass.package_length" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @keydown.right.prevent="$refs.classBoxWidth.$el.select()" />
										W:
										<currency-input
											type="text"
											ref="classBoxWidth"
											v-model.trim="itemClass.package_width"
											:precision="1"
											:valueRange="{ min: 0 }"
											class="tbl_int sss2m_int al_right"
											@keydown.left.prevent="$refs.classBoxLength.$el.select()"
											@keydown.right.prevent="$refs.classBoxHeight.$el.select()"
										/>
										H:
										<currency-input type="text" ref="classBoxHeight" v-model.trim="itemClass.package_height" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @keydown.left.prevent="$refs.classBoxWidth.$el.select()" />
										)
										<template v-if="user.company_id == 'hairplus'">
											, Item Weight :
											<currency-input type="text" v-model.trim="itemClass.weight_per_item" :precision="2" class="tbl_int sssm_int al_right" />
										</template>
									</td>
									<th>Dept A</th>
									<td>
										<CodeSelect :width="100" className="tbl_select sm_int" :codes="deptAs" v-model="itemClass.dept_a_code" />
									</td>
								</tr>
								<tr>
									<th>Group</th>
									<td>
										<CodeSelect :width="100" className="tbl_select sm_int" :codes="classGroups" v-model="itemClass.class_group_code" />
									</td>
									<th>Dept B</th>
									<td>
										<CodeSelect :width="100" className="tbl_select sm_int" :codes="deptBs" v-model="itemClass.dept_b_code" />
									</td>
								</tr>
								<tr>
									<th>Category</th>
									<td>
										<CodeSelect :width="100" :codeWidth="110" :nameWidth="500" className="tbl_select sm_int" :codes="categories" v-model="itemClass.category_code" />
									</td>
									<td rowspan="2">
										<a href="javascript:;" @click="openImage(-1, getImageUrl(itemClass.image_file_name))"
											><img v-if="itemClass.image_file_name" :src="getImageUrl(itemClass.image_file_name)" alt="File Not Found" style="max-height:40px;max-width:70px;height:auto;width:auto;"
										/></a>
										<span v-if="!itemClass.image_file_name">Picture</span>
									</td>
									<td rowspan="2" colspan="2">
										<button :disabled="mode == 'add' || !itemClass.code" class="btn" @click="uploadFile()" style="vertical-align:top;margin-top:13px;">{{ !itemClass.image_file_name ? 'Upload' : 'Replace' }}</button>
										<input v-show="false" type="file" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />

										<button :disabled="!itemClass.image_file_name || extraImages.length > 0" class="btn" style="vertical-align:top;margin-top:13px;margin-right:20px;" @click="clear()">Clear</button>
										<template v-if="itemClass.image_file_name">
											<a v-for="(image, index) in extraImages" v-bind:key="image.image_no" href="javascript:;" @click="openImage(index, getImageUrl(image.image_file_name))">
												<img :src="getImageUrl(image.image_file_name)" alt="File Not Found" style="margin-right:10px;max-height:40px;max-width:70px;height:auto;width:auto;" />
											</a>

											<button v-if="extraImages.length < 5" @click="uploadExtraFile()" style="vertical-align:top;margin-top:13px;">Add Extra Picture</button>
											<input v-show="false" type="file" ref="uploadExtraFile" class="file_input_hidden" accept="image/*" @change="uploadExtraFileConfirm()" />
										</template>
									</td>
								</tr>
							</template>
							<template v-else>
								<tr>
									<th>Group</th>
									<td>
										<CodeSelect :width="100" className="tbl_select sm_int" :codes="classGroups" v-model="itemClass.class_group_code" />
									</td>
									<th>Dept A</th>
									<td>
										<CodeSelect :width="100" className="tbl_select sm_int" :codes="deptAs" v-model="itemClass.dept_a_code" />
									</td>
								</tr>
								<tr>
									<th>Category</th>
									<td>
										<CodeSelect :width="100" :codeWidth="110" :nameWidth="500" className="tbl_select sm_int" :codes="categories" v-model="itemClass.category_code" />
									</td>
									<th>Dept B</th>
									<td>
										<CodeSelect :width="100" className="tbl_select sm_int" :codes="deptBs" v-model="itemClass.dept_b_code" />
									</td>
								</tr>

								<tr>
									<template v-if="user.company_id == 'he'">
										<th>Primary Vendor</th>
										<td>
											<CodeSelect :width="100" className="tbl_select sm_int" :codes="vendors" v-model="itemClass.primary_vendor_code" />
										</td>
									</template>
									<template v-else>
										<th>Wig Point</th>
										<td>
											<currency-input type="text" v-model.trim="itemClass.wig_point" :precision="1" :allow-negative="false" class="tbl_int ssm_int al_right" />
										</td>
									</template>
									<td rowspan="2">
										<a href="javascript:;" @click="openImage(-1, getImageUrl(itemClass.image_file_name))"
											><img v-if="itemClass.image_file_name" :src="getImageUrl(itemClass.image_file_name)" alt="File Not Found" style="max-height:40px;max-width:70px;height:auto;width:auto;"
										/></a>
										<span v-if="!itemClass.image_file_name">Picture</span>
									</td>
									<td rowspan="2" colspan="2">
										<button :disabled="mode == 'add' || !itemClass.code" class="btn" @click="uploadFile()" style="vertical-align:top;margin-top:13px;">{{ !itemClass.image_file_name ? 'Upload' : 'Replace' }}</button>
										<input v-show="false" type="file" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />

										<button :disabled="!itemClass.image_file_name || extraImages.length > 0" class="btn" style="vertical-align:top;margin-top:13px;margin-right:20px;" @click="clear()">Clear</button>
										<template v-if="itemClass.image_file_name">
											<a v-for="(image, index) in extraImages" v-bind:key="image.image_no" href="javascript:;" @click="openImage(index, getImageUrl(image.image_file_name))">
												<img :src="getImageUrl(image.image_file_name)" alt="File Not Found" style="margin-right:10px;max-height:40px;max-width:70px;height:auto;width:auto;" />
											</a>

											<button v-if="extraImages.length < 5" @click="uploadExtraFile()" style="vertical-align:top;margin-top:13px;">Add Extra Picture</button>
											<input v-show="false" type="file" ref="uploadExtraFile" class="file_input_hidden" accept="image/*" @change="uploadExtraFileConfirm()" />
										</template>
									</td>
								</tr>
							</template>

							<tr>
								<th></th>
								<td>
									<label for="closed_yn" style="margin-left:5px;"> <input type="checkbox" id="closed_yn" v-model="itemClass.closed_yn" true-value="Y" false-value="N" />Closed</label>
									<label for="active_yn" style="margin-left:15px;"> <input type="checkbox" id="active_yn" v-model="itemClass.active_yn" true-value="Y" false-value="N" />Active</label>
									<label for="bool_hot" style="margin-left:15px;"> <input type="checkbox" id="bool_hot" v-model="itemClass.bool_hot" />Hot</label>
									<label for="bool_new" style="margin-left:15px;"> <input type="checkbox" id="bool_new" v-model="itemClass.bool_new" />New</label>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="view_bottom_bt">
						<span v-if="use_shopify && modifiable" class="mgr_10">
							<span class="int_type mgr_5">
								<select v-model="selected_store_no" :disabled="!isValid">
									<option v-for="(store, index) in shopify_store_list" :key="index" :value="store.store_no">{{ store.store_name }}</option>
								</select>
							</span>
							<a href="javascript:void(0);" :class="!isValid ? 'disable_bt' : 'gray_bt'" @click="updateOnHandWithShopify">Update On-Hand with Shopify</a>
						</span>
						<a v-if="modifiable" href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save {{ headers.class }} Information (Including FOB Cost)</a>
						<!-- <a v-if="modifiable" href="javascript:;" :class="!isDeletable || !isValid ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a> -->
					</div>
				</div>
				<div v-if="items_locked" role="status">
					<p>{{ items_status_message }}</p>
					<button v-if="items_phase === 'refresh_required'" type="button" class="gray_bt" @click="retryItemRefresh()">Reload Items</button>
				</div>
				<div v-show="!user.image_mgmt_only && profile.use_size_code != 'Y'">
					<h4 class="inner_h5">Items<template v-if="fob_cost_link">(Cost = FOB + FOB * Tariff Rate * 0.01)</template></h4>
					<!-- <JqxGrid width="200px;" :source="itemDataAdapter" :columns="itemColumns" :editable="true" :enabletooltips="true" :selectionmode="'multiplecellsadvanced'"> </JqxGrid> -->
					<div class="fixed-table-container" style="height:335px;" v-show="true" ref="div_wrapper_parent">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<fieldset :disabled="items_locked" class="table-wrapper item_batch_fields" ref="div_wrapper_item">
							<table id="item_list" class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:20px;"></th>
										<!-- <th style="text-align:center;width:5%;"><div class="th-text">ID</div></th> -->
										<!-- <th style="text-align:center;width:20%"><div class="th-text">Name</th> -->
										<th v-if="isJC" style="text-align:center;">
											<div class="th-text">Code</div>
										</th>
										<th v-else style="text-align:center;">
											<div class="th-text">Color</div>
										</th>

										<th style="text-align:center;width:48px;" v-if="user.cost_view_yn == 'Y' && user.fob_price_view">
											<div class="th-text">FOB($)</div>
										</th>
										<th style="text-align:center;width:48px;" v-if="user.cost_view_yn == 'Y' && user.fob_price_view">
											<div class="th-text"><span title="Tariff rate">TAR(%)</span></div>
										</th>
										<th style="text-align:center;width:48px;" v-if="user.cost_view_yn == 'Y'">
											<div class="th-text"><span title="FOB + FOB * Tariff Rate * 0.01">Cost($)</span></div>
										</th>

										<th style="text-align:center;width:48px;">
											<div class="th-text">Lock($)</div>
										</th>
										<th style="text-align:center;width:48px;">
											<div class="th-text">Min($)</div>
										</th>

										<th style="text-align:center;width:48px;">
											<div class="th-text">S($)</div>
										</th>
										<th style="text-align:center;width:48px;">
											<div class="th-text">A($)</div>
										</th>
										<th style="text-align:center;width:48px;">
											<div class="th-text">B($)</div>
										</th>
										<th style="text-align:center;width:48px;">
											<div class="th-text">C($)</div>
										</th>

										<th style="text-align:center;width:40px;">
											<div class="th-text">Pack</div>
										</th>
										<th style="text-align:center;width:48px;">
											<div class="th-text">B.Wgt</div>
										</th>

										<th style="text-align:center;width:40px;">
											<div class="th-text">B.L</div>
										</th>
										<th style="text-align:center;width:40px;">
											<div class="th-text">B.W</div>
										</th>
										<th style="text-align:center;width:40px;">
											<div class="th-text">B.H</div>
										</th>

										<th style="text-align:center;width:60px;">
											<div class="th-text">Loc.</div>
										</th>
										<th style="text-align:center;width:55px;">
											<div class="th-text">Rack</div>
										</th>
										<th style="text-align:center;width:45px;">
											<div class="th-text">Sec.</div>
										</th>
										<th style="text-align:center;width:95px;">
											<div class="th-text">Barcode</div>
										</th>

										<th style="text-align:center;width:50px;">
											<div class="th-text">OnHand</div>
										</th>
										<th style="text-align:center;width:20px;">
											<div class="th-text">Act</div>
										</th>

										<!-- <th style="text-align:center;width:3%;"><div class="th-text">Active</div></th> -->
									</tr>
								</thead>

								<tbody>
									<tr v-for="(item, index) in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id && item.item_id == selectedItem.item_id }">
										<td class="al_center"><img v-img v-if="item.image_file_name" :src="getImageUrl(item.image_file_name)" alt="File Not Found" style="cursor: zoom-in;max-height:20px;max-width:20px;height:auto;width:auto;" /></td>
										<td v-if="isJC">
											{{ item.item_code }}
										</td>
										<td v-else :title="item.discount_price ? 'Discount Price : ' + getCurrencyForamt(item.discount_price) : ''">
											<input
												type="text"
												:ref="'color_code' + index"
												v-model.trim="item.color_code"
												maxlength="30"
												class="l_int long_type font_12"
												:disabled="item.item_id"
												:title="item.color_code"
												@focus="$event.target.select()"
												@input="inputNewItemColor(index == items.length - 1)"
												@keydown.enter.prevent="goTo('color_code', index + 1)"
												@keydown.down.prevent="goTo('color_code', index + 1)"
												@keydown.up.prevent="goTo('color_code', index - 1)"
												@keydown.right.prevent="goTo('lock_price', index)"
												@blur="checkColor(item)"
												:style="item.discount_price ? 'color:red' : ''"
											/>
										</td>

										<td class="al_right" v-if="user.cost_view_yn == 'Y' && user.fob_price_view">
											<currency-input
												type="text"
												:ref="'fob' + index"
												v-model="item.fob"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: 0 }"
												@keydown.enter.prevent="goTo('fob', index + 1)"
												@keydown.down.prevent="goTo('fob', index + 1)"
												@keydown.up.prevent="goTo('fob', index - 1)"
												@keydown.right.prevent="goTo('tariff_rate', index)"
												@keydown.left.prevent="goTo('color_code', index)"
												@input="adjustCost(item)"
											/>
										</td>
										<td class="al_right" v-if="user.cost_view_yn == 'Y' && user.fob_price_view">
											<currency-input
												type="text"
												:ref="'tariff_rate' + index"
												v-model="item.tariff_rate"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:precision="1"
												:valueRange="{ min: 0, max: 99.9 }"
												@keydown.enter.prevent="goTo('tariff_rate', index + 1)"
												@keydown.down.prevent="goTo('tariff_rate', index + 1)"
												@keydown.up.prevent="goTo('tariff_rate', index - 1)"
												@keydown.right.prevent="goTo('cost', index)"
												@keydown.left.prevent="goTo('fob', index)"
												@input="adjustCost(item)"
											/>
										</td>
										<td class="al_right" v-if="user.cost_view_yn == 'Y'">
											<currency-input
												type="text"
												:ref="'cost' + index"
												v-model="item.cost"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												:readonly="fob_cost_link && user.company_id != 'beautyplus'"
												@focus="$event.target.select()"
												:valueRange="{ min: 0 }"
												@keydown.enter.prevent="goTo('cost', index + 1)"
												@keydown.down.prevent="goTo('cost', index + 1)"
												@keydown.up.prevent="goTo('cost', index - 1)"
												@keydown.right.prevent="goTo('lock_price', index)"
												@keydown.left.prevent="goTo('tariff_rate', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'lock_price' + index"
												v-model="item.lock_price"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: 0 }"
												@keydown.enter.prevent="goTo('lock_price', index + 1)"
												@keydown.down.prevent="goTo('lock_price', index + 1)"
												@keydown.up.prevent="goTo('lock_price', index - 1)"
												@keydown.right.prevent="goTo('min_price', index)"
												@keydown.left.prevent="goTo('cost', index)"
											/>
										</td>
										<td class="al_right">
											<currency-input
												type="text"
												:ref="'min_price' + index"
												v-model="item.min_price"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: item.lock_price }"
												@keydown.enter.prevent="goTo('min_price', index + 1)"
												@keydown.down.prevent="goTo('min_price', index + 1)"
												@keydown.up.prevent="goTo('min_price', index - 1)"
												@keydown.right.prevent="goTo('s_price', index)"
												@keydown.left.prevent="goTo('lock_price', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'s_price' + index"
												v-model="item.s_price"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: 0 }"
												@keydown.enter.prevent="goTo('s_price', index + 1)"
												@keydown.down.prevent="goTo('s_price', index + 1)"
												@keydown.up.prevent="goTo('s_price', index - 1)"
												@keydown.right.prevent="goTo('a_price', index)"
												@keydown.left.prevent="goTo('min_price', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'a_price' + index"
												v-model="item.a_price"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: item.min_price }"
												@keydown.enter.prevent="goTo('a_price', index + 1)"
												@keydown.down.prevent="goTo('a_price', index + 1)"
												@keydown.up.prevent="goTo('a_price', index - 1)"
												@keydown.right.prevent="goTo('b_price', index)"
												@keydown.left.prevent="goTo('s_price', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'b_price' + index"
												v-model="item.b_price"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: item.a_price }"
												@keydown.enter.prevent="goTo('b_price', index + 1)"
												@keydown.down.prevent="goTo('b_price', index + 1)"
												@keydown.up.prevent="goTo('b_price', index - 1)"
												@keydown.right.prevent="goTo('c_price', index)"
												@keydown.left.prevent="goTo('a_price', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'c_price' + index"
												v-model="item.c_price"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												:valueRange="{ min: item.b_price }"
												@keydown.enter.prevent="goTo('c_price', index + 1)"
												@keydown.down.prevent="goTo('c_price', index + 1)"
												@keydown.up.prevent="goTo('c_price', index - 1)"
												@keydown.right.prevent="goTo('packing', index)"
												@keydown.left.prevent="goTo('b_price', index)"
											/>
										</td>

										<td>
											<currency-input
												type="text"
												:ref="'packing' + index"
												v-model.trim="item.packing"
												class="l_int long_type al_right font_12"
												:precision="0"
												:allow-negative="false"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('packing', index + 1)"
												@keydown.down.prevent="goTo('packing', index + 1)"
												@keydown.up.prevent="goTo('packing', index - 1)"
												@keydown.right.prevent="goTo('weight_per_box', index)"
												@keydown.left.prevent="goTo('c_price', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'weight_per_box' + index"
												v-model="item.weight_per_box"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												:allow-negative="false"
												:precision="2"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('weight_per_box', index + 1)"
												@keydown.down.prevent="goTo('weight_per_box', index + 1)"
												@keydown.up.prevent="goTo('weight_per_box', index - 1)"
												@keydown.right.prevent="goTo('box_length', index)"
												@keydown.left.prevent="goTo('packing', index)"
											/>
										</td>

										<td class="al_right">
											<currency-input
												type="text"
												:ref="'box_length' + index"
												v-model="item.box_length"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												:allow-negative="false"
												:precision="1"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('box_length', index + 1)"
												@keydown.down.prevent="goTo('box_length', index + 1)"
												@keydown.up.prevent="goTo('box_length', index - 1)"
												@keydown.right.prevent="goTo('box_width', index)"
												@keydown.left.prevent="goTo('weight_per_box', index)"
											/>
										</td>
										<td class="al_right">
											<currency-input
												type="text"
												:ref="'box_width' + index"
												v-model="item.box_width"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												:allow-negative="false"
												:precision="1"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('box_width', index + 1)"
												@keydown.down.prevent="goTo('box_width', index + 1)"
												@keydown.up.prevent="goTo('box_width', index - 1)"
												@keydown.right.prevent="goTo('box_height', index)"
												@keydown.left.prevent="goTo('box_length', index)"
											/>
										</td>
										<td class="al_right">
											<currency-input
												type="text"
												:ref="'box_height' + index"
												v-model="item.box_height"
												class="r_int long_type al_right font_12"
												:disabled="!item.color_code && !isJC"
												:allow-negative="false"
												:precision="1"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('box_height', index + 1)"
												@keydown.down.prevent="goTo('box_height', index + 1)"
												@keydown.up.prevent="goTo('box_height', index - 1)"
												@keydown.right.prevent="goTo('rack', index)"
												@keydown.left.prevent="goTo('box_width', index)"
											/>
										</td>

										<td>
											<!-- {{ item.location_name }} -->
											<!-- <CodeSelect className="tbl_select" :width="83" :codes="locations" v-model="item.location_code" /> -->
											<select v-model="item.location_code" class="tbl_select font_12" :disabled="!item.color_code && !isJC">
												<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
											</select>
										</td>
										<td>
											<input
												type="text"
												:ref="'rack' + index"
												v-model.trim="item.rack"
												class="l_int long_type font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('rack', index + 1)"
												@keydown.down.prevent="goTo('rack', index + 1)"
												@keydown.up.prevent="goTo('rack', index - 1)"
												@keydown.right.prevent="goTo('section', index)"
												@keydown.left.prevent="goTo('box_height', index)"
											/>
										</td>
										<td>
											<input
												type="text"
												:ref="'section' + index"
												v-model.trim="item.section"
												class="l_int long_type font_12"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('section', index + 1)"
												@keydown.down.prevent="goTo('section', index + 1)"
												@keydown.up.prevent="goTo('section', index - 1)"
												@keydown.right.prevent="goTo('barcode', index)"
												@keydown.left.prevent="goTo('rack', index)"
											/>
										</td>
										<td>
											<input
												type="text"
												:ref="'barcode' + index"
												v-model.trim="item.barcode"
												class="l_int long_type font_11"
												:disabled="!item.color_code && !isJC"
												@focus="$event.target.select()"
												@keydown.enter.prevent="goTo('barcode', index + 1)"
												@keydown.down.prevent="goTo('barcode', index + 1)"
												@keydown.up.prevent="goTo('barcode', index - 1)"
												@keydown.left.prevent="goTo('section', index)"
											/>
										</td>
										<td class="al_right font_12">{{ item.on_hand | commaSeparated }}</td>
										<td class="al_center">
											<input type="checkbox" id="active_yn" v-model="item.active_yn" true-value="Y" false-value="N" :disabled="!item.color_code && !isJC" />
										</td>
										<!-- <td style="text-align:center;">{{ item.active_yn }}</td> -->
									</tr>
								</tbody>
							</table>
						</fieldset>
						<div class="view_bottom_bt">
							<a v-if="modifiable" href="javascript:;" :class="!isValid || items_locked ? 'disable_bt' : 'search_bt'" :aria-disabled="items_locked" @click="saveItems()">Save Item(s)</a>
							<!-- <a v-if="modifiable" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <Modal @close="closeModal" v-if="showModal && modalName == 'ItemDetail'" :draggable="false">
			<template slot="title">Item Detail</template>
			<template slot="body">
				<ItemDetail :selectedItem="selectedItem" :modifiable="modifiable" v-on:close="closeModal()" @set-item="setItem" />
			</template>
		</Modal> -->
		<Modal @close="closeModal" v-if="showModal && modalName == 'Image'" :draggable="false">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Images</template>
			<template slot="body">
				<div style="width:600px; height:800px;display: flex;justify-content: center;align-items:center;">
					<img v-img :src="imageUrl" alt="File Not Found" style="cursor: zoom-in;max-height:740px;max-width:580px;height:auto;width:auto;display:block;margin: 0px auto;" />
					<!-- <img v-img :src="imageUrl" alt="File Not Found" style="display:block;margin:auto;" /> -->
				</div>
				<div style="display: flex;justify-content: right;align-items:right;">
					<button :disabled="this.curIndex == -1" style="margin-left:10px;margin-bottom:10px;text-align:right;" @click="keyArrow(-1)">&#60;&#60; Prev</button>
					<button :disabled="this.curIndex == this.extraImages.length - 1" style="margin-left:10px;margin-bottom:10px;text-align:right;" @click="keyArrow(1)">Next &#62;&#62;</button>
					<button :disabled="this.curIndex == -1" style="margin-left:40px;margin-bottom:10px;text-align:right;" @click="deleteExtraImage()">Delete</button>

					<button style="margin-left:40px;margin-bottom:10px;text-align:right;" @click="closeModal()">Close</button>
				</div>
			</template>
		</Modal>

		<Modal @close="closeBulkPictureModal" v-if="showModal && modalName == 'BulkPicture'" :draggable="false">
			<template slot="title">Bulk Upload Pictures</template>
			<template slot="body">
				<div style="width:700px; min-height:400px; padding:15px;">
					<div v-if="bulk_picture_phase == 'preview'">
						<h2 style="margin-bottom:10px;">Selected {{ bulk_picture_files.length }} image file(s) from folder</h2>
						<p style="color:#666; margin-bottom:10px;">
							File names (without extension) will be matched against Class Code.<br />
							Supported formats: jpg, jpeg, png, gif, bmp, webp
						</p>
						<div style="max-height:300px; overflow-y:auto; border:1px solid #ddd; padding:10px;">
							<table style="width:100%; table-layout:fixed;">
								<colgroup>
									<col />
									<col style="width:35%;" />
									<col style="width:90px;" />
								</colgroup>
								<thead>
									<tr style="background:#f5f5f5;">
										<th style="text-align:left; padding:5px;">File Name</th>
										<th style="text-align:left; padding:5px;">Class Code</th>
										<th style="text-align:right; padding:5px;">Size</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(f, idx) in bulk_picture_files" :key="idx">
										<td style="padding:5px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ f.name }}</td>
										<td style="padding:5px; color:blue; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ bulkPictureClassCode(f.name) }}</td>
										<td style="padding:5px; text-align:right; white-space:nowrap;">{{ (f.size / 1024).toFixed(1) }} KB</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="popup_bottom" style="margin-top:15px;">
							<a href="javascript:;" class="search_bt" :class="bulk_picture_uploading ? 'disable_bt' : 'search_bt'" @click="bulkPictureUpload()">Upload</a>
							<a href="javascript:;" class="gray_bt" @click="closeBulkPictureModal()">Cancel</a>
						</div>
					</div>
					<div v-else-if="bulk_picture_phase == 'uploading'" class="al_center" style="padding:80px 0;">
						<h2>Uploading batch {{ bulk_picture_progress_current }} / {{ bulk_picture_progress_total }}...</h2>
						<p style="color:#666; margin-top:10px;">Processed {{ bulk_picture_processed }} of {{ bulk_picture_files.length }} files</p>
					</div>
					<div v-else-if="bulk_picture_phase == 'result'">
						<h2 style="margin-bottom:10px;">Upload Result</h2>
						<div style="margin-bottom:15px;">
							<span style="color:green; margin-right:20px;">Success: {{ bulk_picture_result.success_count }}</span>
							<span style="color:orange; margin-right:20px;">Not Found: {{ bulk_picture_result.not_found_count }}</span>
							<span style="color:red;">Failed: {{ bulk_picture_result.failed_count }}</span>
						</div>
						<div style="max-height:350px; overflow-y:auto; border:1px solid #ddd; padding:10px;">
							<table style="width:100%;">
								<thead>
									<tr style="background:#f5f5f5;">
										<th style="text-align:left; padding:5px;">File</th>
										<th style="text-align:left; padding:5px;">Class Code</th>
										<th style="text-align:left; padding:5px;">Status</th>
										<th style="text-align:left; padding:5px;">Message</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(r, idx) in bulk_picture_result.items" :key="idx">
										<td style="padding:5px;">{{ r.filename }}</td>
										<td style="padding:5px;">{{ r.code }}</td>
										<td style="padding:5px;" :style="'color:' + (r.status == 'success' ? 'green' : r.status == 'not_found' ? 'orange' : 'red')">{{ r.status }}</td>
										<td style="padding:5px;">{{ r.msg || '' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="popup_bottom" style="margin-top:15px;">
							<a href="javascript:;" class="search_bt" @click="closeBulkPictureModal()">Close</a>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import {
	apiIndex,
	apiSelectItemClassList,
	apiCheckItemClassExists,
	apiInsertItemClass,
	apiUpdateItemClass,
	apiDeleteItemClass,
	apiInsertPicture,
	apiDeletePicture,
	apiBulkUploadPictures,
	apiSelectFobPriceList,
	apiInsertExtraImage,
	apiSelectExtraImageList,
	apiDeleteExtraImage,
	apiClearWhCode,
	apiSetNewWhCode,
	apiSelectNewAutoClassCode,
} from '@/api/item/class.js';
import { apiGetShopifyStoreList, apiSetThirdPartyStoreSetting } from '@/api/shopify/shopify_common.js';
import { apiTransferItemClassToShopify, apiUpdateItemClassOnHandWithShopify } from '@/api/shopify/shopify_item.js';
import { apiCheckPartnerExists } from '@/api/partner/index.js';
import { apiSelectItemList, apiBatchSubmit } from '@/api/item/master';
import { apiUploadFile } from '@/api/util.js';
import { toCurrency } from '@/utils/etc.js';
//import { headerClass } from '@/api/headers.js';
import _ from 'lodash';
import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CodeSelect from '@/components/common/CodeSelect';
import Modal from '@/components/common/Modal';
//import ItemDetail from '@/components/common/ItemDetail';
import '@/assets/css/table_box.css';
//import JqxGrid from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue';

export default {
	data: function() {
		return {
			classGroups: [],
			deptAs: [],
			deptBs: [],
			categories: [],
			locations: [],
			colors: [],
			items_phase: 'ready',
			items_generation: 0,
			items_refresh_class: null,
			items_save_outcome: null,

			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			list_count: 0,

			classGroup: null,
			deptA: null,
			deptB: null,
			category: null,

			keyword: '',
			closed_yn: 'N',
			active_yn: 'Y',
			hot_yn: '',
			new_yn: '',
			discount_yn: '',
			mode: null,

			itemClasses: [],
			selectedItemClass: {},

			itemClass: {},

			fobs: [],
			items: [],
			new_item: {},

			selectedItem: {},
			modalName: '',
			showModal: false,

			bulk_picture_files: [],
			bulk_picture_phase: 'preview',
			bulk_picture_uploading: false,
			bulk_picture_result: { items: [], success_count: 0, not_found_count: 0, failed_count: 0 },
			bulk_picture_progress_current: 0,
			bulk_picture_progress_total: 0,
			bulk_picture_processed: 0,

			colorCodes: [],
			bool_hot: false,
			bool_new: false,
			// itemDataAdapter: null, //new jqx.dataAdapter(this.source),
			// itemColumns: [
			// 	{ text: 'First Name', columntype: 'textbox', datafield: 'firstname', width: 200 },
			// 	{ text: 'Last Name', datafield: 'lastname', columntype: 'textbox', width: 200 },
			// ],
			imageOpen: false,
			imageUrl: null,

			extraImages: [],
			curIndex: -1,

			ups_divisor: null,
			fob_cost_link: null,

			vendors: [],

			// shopify
			selected_store_no: null,
			shopify_store_list: [],
		};
	},
	props: ['headers'],
	computed: {
		items_locked() {
			return this.items_phase !== 'ready';
		},
		items_status_message() {
			if (this.items_phase === 'posting') return 'Saving items...';
			if (this.items_phase === 'refreshing') return 'Loading items and colors...';
			if (this.items_save_outcome === 'saved') return 'Items were saved. Reload the list before editing or saving again.';
			if (this.items_save_outcome === 'unknown') return 'The save result could not be confirmed. Reload and check the items before making further changes.';
			return 'The item list could not be loaded. Reload the list to continue.';
		},
		user: function() {
			return this.$session.get('user');
		},
		isJC() {
			return this.$session.get('user').company_id == 'jc' ? true : false;
		},
		profile: function() {
			return this.$session.get('profile');
		},
		use_shopify() {
			return this.profile.shopify === 'Y';
		},
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		isValid() {
			if (!this.itemClass.code) return false;
			else return true;
		},
		isDeletable() {
			//if (this.mode == 'detail' && this.codes.length > 0 && this.code) return true;
			if (this.mode == 'detail' && this.selectedItemClass) return true;
			else return false;
		},
		modifiable() {
			if (this.user.image_mgmt_only) return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	watch: {
		selected_store_no: {
			handler() {
				this.setThirdPartyStoreSetting();
			},
		},
	},
	components: {
		Paging,
		CodeSelect,
		Modal,
		PageSizeSelect,
		//ItemDetail,
		//JqxGrid,
	},
	methods: {
		async setNewWhCode() {
			var param = {
				code: this.itemClass.code,
				class_group_code: this.itemClass.class_group_code,
			};
			var response = await apiSetNewWhCode(param);
			//console.log(response);
			if (response.data.result) {
				this.$toast.success('New code set successfully');
				this.itemClass.wh_code = response.data.wh_code;
				this.selectedItemClass.wh_code = response.data.wh_code;
			}
		},
		async clearWhCode() {
			if (confirm('Are you sure to clear the wharehouse code')) {
				var param = {
					code: this.itemClass.code,
				};
				var response = await apiClearWhCode(param);
				if (response.data.result) {
					this.$toast.success('Cleared successfully');
					this.itemClass.wh_code = null;
					this.selectedItemClass.wh_code = null;
				}
			}
		},
		getUpsDimWeight() {
			if (this.itemClass && this.itemClass.box_length > 0 && this.itemClass.box_width > 0 && this.itemClass.box_height && this.ups_divisor > 0)
				return (this.itemClass.box_length * this.itemClass.box_width * this.itemClass.box_height) / this.ups_divisor;
			else return null;
		},
		adjustCost(item) {
			if (this.items_locked) return;
			if (!this.fob_cost_link) return;

			item.cost = item.fob + item.fob * item.tariff_rate * 0.01;
		},
		// imageOpened() {
		// 	//console.log('image opended');
		// 	this.imageOpen = true;
		// },
		// imageClosed() {
		// 	//console.log('image closed');
		// 	this.imageOpen = false;
		// },
		mainChanged(fob, index) {
			// if (fob.main) {
			// 	this.fobs
			// 		.filter(f => f.vendor_code != fob.vendor_code)
			// 		.forEach(f => {
			// 			f.main = false;
			// 		});
			// 	if (index > 0) {
			// 		var topFob = _.cloneDeep(fob);
			// 		this.fobs.splice(index, 1);
			// 		this.fobs.unshift(topFob);
			// 	}
			// }
			// for (var j = 1; j < this.fobs.length; j++) {
			// 	this.$refs.fobCheck[j].checked = false;
			// }
			for (var i = 0; i < this.fobs.length; i++) {
				if (i != index) this.fobs[i].main = false;
			}
		},
		addFobRow() {
			if (!this.isValid) return;
			//this.fobs.push({ vendor_code: '', price: null });
			this.fobs.unshift({ vendor_code: '', price: null });
		},
		delRow(index) {
			this.fobs.splice(index, 1);
		},
		async checkVendor(fob) {
			if (fob.vendor_code) {
				// if (this.fobs.filter(f => f.vendor_code && f.vendor_code.toUpperCase() == fob.vendor_code.toUpperCase()).length > 1) {
				// 	this.$toast.error('Duplicate Vendor Exists.');
				// 	fob.vendor_code = null;
				// 	return;
				// }

				const { data } = await apiCheckPartnerExists({ code: fob.vendor_code, vendor_only: true });
				if (!data.result) {
					this.$toast.error('Vendor Not Exists.');
					fob.vendor_code = null;
					return;
				}
			}
		},
		async checkColor(item) {
			if (this.items_locked) return;
			//console.log(color_code);1
			if (item.color_code) {
				if (this.colors.filter(c => c.code.toUpperCase() == item.color_code.toUpperCase()).length == 0) {
					this.$toast.warning(item.color_code + ' does not exist in Code Table and will be added as a new color code');
				} else {
					item.color_code = this.colors.filter(c => c.code.toUpperCase() == item.color_code.toUpperCase())[0].code;
				}

				if (item.color_code.toUpperCase() == 'MQ') item.packing = 0;
			}
		},
		async clear() {
			if (confirm('Are you sure to delete the picture?')) {
				var picture = {
					code: this.itemClass.code,
				};
				var response = await apiDeletePicture(picture);
				if (response.data.result) {
					this.$toast.success('File deleted successfully');
					this.itemClass.image_file_name = null;
					this.selectedItemClass.image_file_name = null;
				}
			}
		},
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			var file = this.$refs.uploadFile.files[0];
			var response = await apiUploadFile(file);
			if (response.data.result) {
				var newFilename = response.data.filename;
				var picture = {
					code: this.itemClass.code,
					image_file_name: newFilename,
				};
				response = await apiInsertPicture(picture);
				if (response.data.result) {
					this.$toast.success('File uploaded successfully');
					this.itemClass.image_file_name = newFilename;
					this.selectedItemClass.image_file_name = newFilename;
					this.$refs.uploadFile.value = null;
				}
			}
		},
		async uploadExtraFile() {
			const elem = this.$refs.uploadExtraFile;
			elem.click();
		},
		async uploadExtraFileConfirm() {
			//console.log('test');
			var file = this.$refs.uploadExtraFile.files[0];
			var response = await apiUploadFile(file);
			if (response.data.result) {
				var newFilename = response.data.filename;
				var picture = {
					class_code: this.itemClass.code,
					image_file_name: newFilename,
				};
				response = await apiInsertExtraImage(picture);
				if (response.data.result) {
					this.$toast.success('File uploaded successfully');
					this.extraImages.push({ image_no: response.data.image_no, image_file_name: newFilename });

					this.$refs.uploadExtraFile.value = null;
					//this.itemClass.image_file_name = newFilename;
					//console.log(response);
				}
			}
		},
		async deleteExtraImage() {
			//console.log(this.extraImages[this.curIndex]);
			if (confirm('Are you sure to delete the picture?')) {
				var picture = {
					image_no: this.extraImages[this.curIndex].image_no,
				};

				var isLast = false;
				if (this.curIndex == this.extraImages.length - 1) isLast = true;

				var response = await apiDeleteExtraImage(picture);
				if (response.data.result) {
					this.$toast.success('File deleted successfully');
					this.extraImages.splice(this.curIndex, 1);

					if (this.extraImages.length == 0) {
						//this.closeModal();
						this.openImage(-1, this.getImageUrl(this.itemClass.image_file_name));
					} else if (this.extraImages.length > 0) {
						if (isLast) this.openImage(this.curIndex - 1, this.getImageUrl(this.extraImages[this.curIndex - 1].image_file_name));
						else this.openImage(this.curIndex, this.getImageUrl(this.extraImages[this.curIndex].image_file_name));
					}
					//this.itemClass.image_file_name = null;
				}
			}
		},
		getImageUrl(image_file_name) {
			//var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + it.image_file_name;
			var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + image_file_name;
			return url;
		},
		applyTariffRateToItems() {
			if (this.items_locked) return;
			var vm = this;
			this.items
				.filter(i => i.color_code && !this.isException(i))
				.forEach(i => {
					i.tariff_rate = this.itemClass.tariff_rate;
					vm.adjustCost(i);
				});
		},
		applyPackingToItems() {
			if (this.items_locked) return;
			this.items
				.filter(i => i.color_code && !this.isException(i))
				.forEach(i => {
					i.packing = this.itemClass.packing;
				});
		},
		applyWeightPerBoxToItems() {
			if (this.items_locked) return;
			this.items
				.filter(i => i.color_code && !this.isException(i))
				.forEach(i => {
					i.weight_per_box = this.itemClass.weight_per_box;
				});
		},
		applyRackSectionToItems() {
			if (this.items_locked) return;
			this.items
				.filter(i => i.color_code && !this.isException(i))
				.forEach(i => {
					i.rack = this.itemClass.rack;
					i.section = this.itemClass.section;
				});
		},
		applyDimensionToItems() {
			if (this.items_locked) return;
			this.items
				.filter(i => i.color_code && !this.isException(i))
				.forEach(i => {
					i.box_length = this.itemClass.box_length;
					i.box_width = this.itemClass.box_width;
					i.box_height = this.itemClass.box_height;
				});
		},
		applyLocationToItems() {
			if (this.items_locked) return;
			this.items
				.filter(i => i.color_code && !this.isException(i))
				.forEach(i => {
					i.location_code = this.itemClass.location_code;
				});
		},
		isException(item) {
			if (item.color_code == 'MQ' || item.color_code == 'SB' || item.color_code.toUpperCase().includes('BOARD') || item.name.toUpperCase().includes('BANNER') || item.name.toUpperCase().includes('POSTER')) return true;

			return false;
		},
		async saveItems() {
			if (this.items_locked || !this.isValid || !this.selectedItemClass.code) return;
			const valid_items = this.isJC ? this.items : this.items.filter(i => i.color_code);
			if (valid_items.length === 0) {
				this.$toast.error('Nothing to save');
				return;
			}
			if (valid_items.some(i => i.cost == null)) {
				this.$toast.error('Empty Cost');
				return;
			}
			if (valid_items.some(i => valid_items.filter(other => other.color_code === i.color_code).length > 1)) {
				this.$toast.error('Duplicate Color Code');
				return;
			}
			const class_code = this.selectedItemClass.code;
			const items = valid_items.map(item => {
				const row = { ...item, class_code, class_name: this.selectedItemClass.name };
				delete row.is_new_color;
				if (row.item_id == null && !this.colors.some(color => color.code === row.color_code)) row.is_new_color = true;
				return row;
			});
			this.items_phase = 'posting';
			this.items_refresh_class = class_code;
			this.items_save_outcome = 'unknown';
			const generation = ++this.items_generation;
			try {
				const { data } = await apiBatchSubmit({ items, class_code });
				if (generation !== this.items_generation || this.selectedItemClass.code !== class_code) return;
				if (data && data.result === false) {
					this.items_phase = 'ready';
					this.items_save_outcome = null;
					this.$toast.error(data.msg || 'Items were not saved.');
					return;
				}
				if (!data || data.result !== true) throw new Error('Invalid save response');
				this.items_save_outcome = 'saved';
				await this.refreshItemSnapshot(class_code);
			} catch (error) {
				if (generation === this.items_generation) this.items_phase = 'refresh_required';
			}
		},
		async retryItemRefresh() {
			if (this.items_phase !== 'refresh_required') return;
			await this.refreshItemSnapshot(this.items_refresh_class);
		},
		async refreshItemSnapshot(class_code) {
			if (!class_code || class_code !== this.selectedItemClass.code) return;
			this.items_phase = 'refreshing';
			this.items_refresh_class = class_code;
			const generation = ++this.items_generation;
			try {
				// Keep both responses private until they can replace the old, possibly committed draft together.
				const [item_response, color_response] = await Promise.all([apiSelectItemList({ class_code, active_yn: 'Y', paging_yn: 'N', active_po_check: true }), apiIndex()]);
				if (generation !== this.items_generation || class_code !== this.selectedItemClass.code) return;
				const items = item_response.data && item_response.data.itemList;
				const colors = color_response.data && color_response.data.colorList;
				if (!Array.isArray(items) || items.some(item => !item || typeof item.item_id !== 'string' || !item.item_id.trim()) || !Array.isArray(colors)) {
					throw new Error('Invalid item snapshot');
				}
				this.items = items.map(item => ({ ...item }));
				if (!this.isJC) this.items.push({ color_code: '', active_yn: 'Y' });
				this.colors = colors;
				this.items_phase = 'ready';
				if (this.items_save_outcome === 'saved') this.$toast.success('Items saved and list refreshed successfully');
				this.items_save_outcome = null;
				if (this.$refs.div_wrapper_item) this.$refs.div_wrapper_item.scrollTop = 0;
			} catch (error) {
				if (generation === this.items_generation) this.items_phase = 'refresh_required';
			}
		},
		goTo(colType, index) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					//console.log(colType, index);
					//console.log(this.$refs.lock_price[index]);
					//console.log(this.$refs['lock_price' + index][0]);
					//if (colType == 'color_code') this.$refs.color_code[index].select();
					var comp = null;
					if (colType == 'color_code' || colType == 'rack' || colType == 'section' || colType == 'barcode') comp = this.$refs[colType + index][0];
					//.select();
					else comp = this.$refs[colType + index][0].$el; //.select();
					comp.select();

					if (comp.offsetParent.offsetTop + 2 * comp.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight - 20) this.$refs.div_wrapper_item.scrollTop += comp.offsetParent.scrollHeight + 1;
					else if (this.$refs.div_wrapper_item.scrollTop > comp.offsetParent.offsetTop) this.$refs.div_wrapper_item.scrollTop = comp.offsetParent.offsetTop;
					//else if (colType == 'lock_price') this.$refs.lock_price[index].$el.select();
					// else if (colType == 'lock_price') this.$refs['lock_price' + index][0].$el.select();
					// else if (colType == 'min_price') this.$refs.min_price[index].$el.select();
					// else if (colType == 's_price') this.$refs.s_price[index].$el.select();
					// else if (colType == 'a_price') this.$refs.a_price[index].$el.select();
					// else if (colType == 'b_price') this.$refs.b_price[index].$el.select();
					// else if (colType == 'c_price') this.$refs.c_price[index].$el.select();
					// else if (colType == 'packing') this.$refs.packing[index].$el.select();
					// else if (colType == 'weight_per_box') this.$refs.weight_per_box[index].$el.select();
					// else if (colType == 'cost') this.$refs.cost[index].$el.select();
					// else if (colType == 'rack') this.$refs.rack[index].select();
					// else if (colType == 'section') this.$refs.section[index].select();
					// else if (colType == 'barcode') this.$refs.barcode[index].select();
				}
			});
		},
		inputNewItemColor(lastRow) {
			if (this.items_locked) return;
			if (this.isJC) return;
			//console.log(lastRow, this.items.length);

			if (lastRow) {
				if (this.items.length > 1) {
					var li = this.items[this.items.length - 2];
					// this.items[this.items.length - 1].color_code = li.color_code;
					this.items[this.items.length - 1].lock_price = li.lock_price;
					this.items[this.items.length - 1].min_price = li.min_price;
					this.items[this.items.length - 1].s_price = li.s_price;
					this.items[this.items.length - 1].a_price = li.a_price;
					this.items[this.items.length - 1].b_price = li.b_price;
					this.items[this.items.length - 1].c_price = li.c_price;
					this.items[this.items.length - 1].fob = li.fob;
					this.items[this.items.length - 1].tariff_rate = li.tariff_rate;
					this.items[this.items.length - 1].cost = li.cost;
					this.items[this.items.length - 1].packing = li.packing;
					this.items[this.items.length - 1].weight_per_box = li.weight_per_box;
					this.items[this.items.length - 1].location_code = li.location_code;
					this.items[this.items.length - 1].rack = li.rack;
					this.items[this.items.length - 1].section = li.section;
					this.items[this.items.length - 1].active_yn = li.active_yn;
				} else if (this.items.length == 1 && !this.items[0].packing) {
					this.items[0].packing = this.itemClass.packing;
					this.items[0].weight_per_box = this.itemClass.weight_per_box;
					this.items[0].rack = this.itemClass.rack;
					this.items[0].section = this.itemClass.section;
				}

				this.items.push({ color_code: '', active_yn: 'Y' });
			}
		},
		// openModal(modalName, item) {
		// 	this.selectedItem = item;
		// 	this.modalName = modalName;
		// 	this.showModal = true;
		// },
		openImage(index, url) {
			//console.log(index, url);
			this.curIndex = index;
			this.imageUrl = url;
			this.modalName = 'Image';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		bulkPictureFolderPick() {
			this.$refs.bulkPictureInput.value = null;
			this.$refs.bulkPictureInput.click();
		},
		bulkPictureClassCode(filename) {
			if (!filename) return '';
			var dot_idx = filename.lastIndexOf('.');
			return dot_idx > 0 ? filename.substring(0, dot_idx) : filename;
		},
		bulkPictureFolderSelected() {
			var all_files = Array.from(this.$refs.bulkPictureInput.files || []);
			var image_exts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
			var image_files = all_files.filter(function(f) {
				var dot_idx = f.name.lastIndexOf('.');
				if (dot_idx < 0) return false;
				var ext = f.name.substring(dot_idx + 1).toLowerCase();
				return image_exts.indexOf(ext) >= 0;
			});
			if (image_files.length == 0) {
				this.$toast.error('No image files found in the selected folder');
				return;
			}
			this.bulk_picture_files = image_files;
			this.bulk_picture_phase = 'preview';
			this.bulk_picture_uploading = false;
			this.bulk_picture_result = { items: [], success_count: 0, not_found_count: 0, failed_count: 0 };
			this.showModal = true;
			this.modalName = 'BulkPicture';
		},
		async bulkPictureUpload() {
			if (this.bulk_picture_uploading) return;
			this.bulk_picture_uploading = true;
			this.bulk_picture_phase = 'uploading';

			// Split into batches of ~50MB each (server max-request-size is 100MB)
			var MAX_BATCH_SIZE = 50 * 1024 * 1024;
			var batches = [];
			var current_batch = [];
			var current_size = 0;
			this.bulk_picture_files.forEach(function(f) {
				if (current_size + f.size > MAX_BATCH_SIZE && current_batch.length > 0) {
					batches.push(current_batch);
					current_batch = [];
					current_size = 0;
				}
				current_batch.push(f);
				current_size += f.size;
			});
			if (current_batch.length > 0) batches.push(current_batch);

			this.bulk_picture_progress_total = batches.length;
			this.bulk_picture_progress_current = 0;
			this.bulk_picture_processed = 0;

			var agg = { items: [], success_count: 0, not_found_count: 0, failed_count: 0 };

			try {
				for (var i = 0; i < batches.length; i++) {
					this.bulk_picture_progress_current = i + 1;
					var batch = batches[i];
					try {
						var response = await apiBulkUploadPictures(batch);
						if (response.data.result) {
							agg.items = agg.items.concat(response.data.items || []);
							agg.success_count += response.data.success_count || 0;
							agg.not_found_count += response.data.not_found_count || 0;
							agg.failed_count += response.data.failed_count || 0;
						} else {
							batch.forEach(f => {
								agg.items.push({ filename: f.name, code: this.bulkPictureClassCode(f.name), status: 'failed', msg: 'Batch request failed' });
								agg.failed_count++;
							});
						}
					} catch (e) {
						batch.forEach(f => {
							agg.items.push({ filename: f.name, code: this.bulkPictureClassCode(f.name), status: 'failed', msg: 'Network/server error' });
							agg.failed_count++;
						});
					}
					this.bulk_picture_processed += batch.length;
				}

				this.bulk_picture_result = agg;
				this.bulk_picture_phase = 'result';
				this.$toast.success('Bulk upload completed');
				if (agg.success_count > 0) this.search();
			} finally {
				this.bulk_picture_uploading = false;
			}
		},
		closeBulkPictureModal() {
			this.showModal = false;
			this.modalName = null;
			this.bulk_picture_files = [];
			this.bulk_picture_phase = 'preview';
			this.$refs.bulkPictureInput.value = null;
		},
		add() {
			if (this.items_locked) return;
			this.mode = 'add';
			this.itemClass = {};
			//this.code.code_type = this.code_type;
			this.itemClass.active_yn = 'Y';
			this.itemClass.closed_yn = 'N';
			this.itemClass.so_blocked = false;
			// var new_code = {
			// 	code_type: this.code_type,
			// 	active_yn: 'Y',
			// };
			//this.codes.push(new_code);

			//this.dlClassGroupItem.unSelectOption();
			this.itemClass.class_group_code = null;
			this.itemClass.dept_a_code = null;
			this.itemClass.dept_a_code = null;
			this.itemClass.category_code = null;
			this.itemClass.image_file_name = null;

			this.fobs = [];
			this.items = [];
			this.selectedItem = {};
			this.selectedItemClass = {};
			this.items_generation++;
			this.$refs.code.focus();

			// this.selectedCode.name = null;
			//this.selectedCode.code_type = this.code_type;
		},
		clone() {
			if (this.items_locked) return;
			this.mode = 'add';
			this.itemClass.code = '';
			this.itemClass.wh_code = '';
			this.itemClass.so_blocked = false;

			this.items = [];
			this.selectedItem = {};
			this.selectedItemClass = {};
			this.items_generation++;
			this.$refs.code.focus();
		},
		async generateCode() {
			const { data } = await apiSelectNewAutoClassCode({ prefix: this.itemClass.code, pad_length: 8 });
			if (data.newCode) this.itemClass.code = data.newCode;
			//console.log(data);
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Code');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckItemClassExists(this.itemClass);
			return data.result;
		},
		search() {
			if (this.items_locked) return;
			this.page_no = 1;
			this.selectItemClasses();
		},
		reset() {
			if (this.items_locked) return;
			this.page_no = 1;
			this.closed_yn = 'N';
			this.active_yn = 'Y';
			this.keyword = '';
			//this.dlClassGroup.unSelectOption();
			this.classGroup = null;
			this.deptA = null;
			this.deptB = null;
			this.category = null;

			if (this.use_shopify) {
				if (Array.isArray(this.shopify_store_list) && this.shopify_store_list.length > 0) {
					this.selected_store_no = this.shopify_store_list[0].store_no;
				}
			}
		},
		async selectItemClasses() {
			if (this.items_locked) return;
			this.mode = 'detail';
			this.itemClass = {};
			this.selectedItemClass = {};
			this.items = [];
			this.items_generation++;

			var param = {
				class_group: this.classGroup,
				dept_a: this.deptA,
				dept_b: this.deptB,
				category: this.category,
				keyword: this.keyword,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				active_yn: this.active_yn,
				closed_yn: this.closed_yn,
				hot_yn: this.hot_yn,
				new_yn: this.new_yn,
				discount_yn: this.discount_yn,
			};

			if (this.use_shopify) {
				param.third_party_store_no = this.selected_store_no;
				param.whether_registered = null; // 현재 사용 안함.
			}

			if (this.keyword) {
				param.active_yn = 'A';
				param.closed_yn = 'A';
			}

			const { data } = await apiSelectItemClassList(param);

			//console.log(data);
			this.itemClasses = data.itemClassList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			//if (this.itemClasses.length > 0) this.selectRow(this.itemClasses[0]);
		},
		async submit() {
			if (this.items_locked) return;
			if (!this.isValid) return;

			if (!this.itemClass.code) {
				this.$toast.error('Empty Code');
				return;
			}

			if (!this.itemClass.name) {
				this.$toast.error('Empty Name');
				return;
			}

			if (!this.itemClass.class_group_code) {
				this.$toast.error('Select Group');
				return;
			}

			if (this.fobs.filter(f => !f.vendor_code || !f.price).length > 0) {
				this.$toast.error('Invalid FOB Price Exists.');
				return;
			}

			for (var i = 0; i < this.fobs.length; i++) this.fobs[i].order_no = i + 1;

			this.itemClass.fobs = this.fobs;

			const generation = this.items_generation;
			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Code');
					return;
				}
				if (generation !== this.items_generation || this.items_locked) return;
				response = await apiInsertItemClass(this.itemClass);
			} else {
				response = await apiUpdateItemClass(this.itemClass);
			}
			if (generation !== this.items_generation || this.items_locked) return;
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					if (this.classGroups.filter(g => g.code == this.itemClass.class_group_code).length == 1) this.itemClass.class_group_name = this.classGroups.filter(g => g.code == this.itemClass.class_group_code)[0].name;
					this.itemClass.wh_code = response.data.wh_code;
					this.itemClasses.unshift(_.cloneDeep(this.itemClass));
				}
				//this.setSelectedItemClass();
				Object.assign(this.selectedItemClass, this.itemClass);
			} else {
				this.$toast.error(data.msg);
			}

			this.mode = 'detail';
		},
		async del() {
			if (this.items_locked) return;
			if (!this.isValid || !this.isDeletable) return;
			// if (!this.isDeletable) return;

			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteItemClass(this.itemClass);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					//this.itemClasses.remove(this.selectedItemClass);
					//this.selectCodes();
					var vm = this;
					const idx = this.itemClasses.findIndex(function(item) {
						return item.code === vm.selectedItemClass.code;
					});
					this.itemClasses.splice(idx, 1);
					this.itemClass = {};
				} else {
					this.$toast.error('Failed');
				}
			}
			//console.log('delete');
		},
		setItem(item) {
			Object.assign(this.selectedItem, item);
		},
		gotoPage(pageNo) {
			if (this.items_locked) return;
			this.page_no = pageNo;
			this.selectItemClasses();
		},
		async selectRow(item) {
			if (this.items_locked) return;
			// console.log(item);
			this.mode = 'detail';
			this.selectedItemClass = item;
			this.items = [];

			this.itemClass = _.cloneDeep(item);

			await Promise.all([this.selectFobPrices(this.itemClass.code), this.selectExtraImageList(this.itemClass.code), this.selectItems(this.itemClass.code)]);

			//console.log(this.itemClass);

			// if (item.class_group_code) this.dlClassGroupItem.setComboValue(item.class_group_code);
			// else this.dlClassGroupItem.unSelectOption();

			//console.log(code);
		},
		async selectExtraImageList(class_code) {
			const { data } = await apiSelectExtraImageList({
				class_code: class_code,
			});

			this.extraImages = data.extraImageList;
			//console.log(this.extraImages);
		},
		async selectFobPrices(class_code) {
			const { data } = await apiSelectFobPriceList({
				class_code: class_code,
			});
			//console.log(data);
			this.fobs = data.fobPriceList;
		},
		async selectItems(class_code) {
			if (this.items_locked || class_code !== this.selectedItemClass.code) return;
			this.items_save_outcome = null;
			await this.refreshItemSnapshot(class_code);
		},
		async index() {
			const { data } = await apiIndex();

			this.classGroups = data.classGroupList;
			this.deptAs = data.deptAList;
			this.deptBs = data.deptBList;
			this.categories = data.categoryList;
			this.locations = data.locationList;
			this.colors = data.colorList;

			this.vendors = data.vendorList;
			//console.log(this.vendors);

			// this.colorCodes = [];
			// var vm = this;
			// var i = 0;
			// this.colors.forEach(c => {
			// 	i++;
			// 	if (i < 10) vm.colorCodes.push(c.code);
			// });
			//console.log(this.colors);
			//console.log(this.colorCodes);

			//this.setDlOptions(this.dlClassGroup, data.classGroupList);
		},
		keyArrow(dir) {
			//console.log(dir);
			if (dir == 1) {
				if (this.curIndex == -1 && this.extraImages.length > 0) {
					this.openImage(0, this.getImageUrl(this.extraImages[0].image_file_name));
				} else if (this.curIndex < this.extraImages.length - 1) {
					this.openImage(this.curIndex + 1, this.getImageUrl(this.extraImages[this.curIndex + 1].image_file_name));
				}
			} else if (dir == -1) {
				if (this.curIndex == 0) {
					this.openImage(-1, this.getImageUrl(this.itemClass.image_file_name));
				} else if (this.curIndex > 0) {
					this.openImage(this.curIndex - 1, this.getImageUrl(this.extraImages[this.curIndex - 1].image_file_name));
				}
			}
		},
		getCurrencyForamt(inputValue) {
			return toCurrency(inputValue);
		},
		async transferItemClassToShopify() {
			if (!this.selected_store_no || !this.itemClass || !this.itemClass.code) return;

			const { data } = await apiTransferItemClassToShopify(this.selected_store_no, this.itemClass.code);
			if (data.result === 'SUCCESS') {
				this.itemClass.program_class_id = data.program_class_id;
				this.selectedItemClass.program_class_id = data.program_class_id;

				this.$toast.success('Transfered Data to Shopify Successfully.');
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateOnHandWithShopify() {
			if (this.items_locked) return;
			if (!this.use_shopify) return;
			if (!this.modifiable) return;
			if (!this.selected_store_no) return;
			if (!this.selectedItemClass.code) return;

			const { data } = await apiUpdateItemClassOnHandWithShopify(this.selected_store_no, this.selectedItemClass.code);
			if (Array.isArray(data.items) && data.items.length > 0) {
				let msg = 'Please Check the Changed On-Hand.\n';
				for (const item of data.items) {
					msg += `${item.item_code}: ${item.before_quantity} -> ${item.after_quantity}\n`;
				}
				window.alert(msg);
				this.selectItems(this.selectedItemClass.code);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async setThirdPartyStoreSetting() {
			const { data } = await apiSetThirdPartyStoreSetting(this.selected_store_no);
			if (data.result !== 'SUCCESS') {
				this.$toast.error('Network Error.');
			}
		},
		async getShopifyStoreList() {
			const { data } = await apiGetShopifyStoreList();
			this.shopify_store_list = data || [];
			if (this.shopify_store_list.length > 0) this.selected_store_no = this.shopify_store_list[0].store_no;
		},
	},
	async created() {
		//this.$store.sideIndex = 1;
		this.$store.commit('setSideIndex', 1);
		//this.$store.selectedMenu = 'nav_li_1';
		this.$store.commit('setSelectedMenu', 'nav_li_item_class');
		this.$store.commit('setSubTitle', 'Item -> Item ' + this.headers.class);

		this.ups_divisor = this.$session.get('profile').ups_divisor;
		this.fob_cost_link = this.$session.get('profile').fob_cost_link == 'Y' ? true : false;
		this.page_size = this.$store.getters['getDefaultPageSize'];
		//console.log(this.ups_divisor);
		if (this.use_shopify) await this.getShopifyStoreList();

		await this.index();
		await this.selectItemClasses();

		window.addEventListener('keydown', e => {
			//console.log(e.key);
			if (this.showModal && this.modalName == 'Image') {
				if (e.key == 'ArrowLeft') {
					//left : 37, right : 39
					this.keyArrow(-1);
				} else if (e.key == 'ArrowRight') {
					this.keyArrow(1);
				}
			}
		});

		//console.log(this.generatedata(10));

		// eslint-disable-next-line no-undef
		// this.itemDataAdapter = new jqx.dataAdapter({
		// 	localdata: [
		// 		{ firstname: 'Gyujung', lastname: 'Kim' },
		// 		{ firstname: 'fdsfsd', lastname: 'fjdslf' },
		// 	],
		// 	datatype: 'json',
		// 	datafileds: [
		// 		{ name: 'firstname', type: 'string' },
		// 		{ name: 'lastname', type: 'string' },
		// 	],
		// 	//id: 'id',
		// });
	},
	beforeDestroy() {
		this.items_generation++;
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style scoped>
.item_batch_fields {
	border: 0;
	padding: 0;
	margin: 0;
	min-width: 0;
}
.font_12 {
	font-size: 12px;
}
.font_11 {
	font-size: 11px;
}
</style>
